<div class="container-table height-100 width-100" [ngClass]="{'table-height-pag': showPagination}">
    <table class="twc-table twc-table-adaptive twc-table-hover twc-mb-1" [class.show-border]="showBorder"
        attr.aria-describedby="{{'OBJECT_BROWSER.TABLE_DESCRIPTION' |
            translate}}">
        <ng-container *ngFor="let column of columns">
            <colgroup *ngIf="isVisible(column)">
                <col [style.width]="column.width ?? ''" [style.min-width]="column.minWidth ?? ''">
            </colgroup>
        </ng-container>
        <thead>
            <tr>
                <ng-container *ngFor="let columnItem of columns">
                    <th *ngIf="isVisible(columnItem)">
                        <ng-container *ngIf="hasToShowMultiselectionCheckbox(columnItem)">
                            <div class="twc-checkbox">
                                <input class="twc-checkbox-input" type="checkbox" id="selectAll"
                                    [(ngModel)]="isCheckAllChecked"
                                    (ngModelChange)="onCheckAllChange($event, columnItem)">
                                <label class="twc-checkbox-label" for="selectAll"></label>
                            </div>
                        </ng-container>
                        <span class="{{columnItem.class}}">{{columnItem.name | translate}}</span>
                    </th>
                </ng-container>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let row of data; index as idx" (click)="onSelectRow(row)" (dblclick)="onDblClickRow(row)"
                [ngClass]="{'selected-row': isSelectedRow(row) && isEnabledSelectRow, 'cursor-pointer': isEnabledSelectRow}">
                <ng-container *ngFor="let item of columns" [ngSwitch]="item.type">
                    <td class="{{(row | resolveProperty: item.field)?.class}}">
                        <ng-container *ngIf="isVisible(item, row)">
                            <ng-container *ngSwitchCase="'icon'">
                                <twc-icon *ngIf="hasIcon(row, item)"
                                    shape="{{(row | resolveProperty: item.field)?.icon}}"
                                    twcTooltip="{{(row | resolveProperty: item.field)?.tooltip | translate}}"
                                    placement="top"></twc-icon>
                            </ng-container>

                            <ng-container *ngSwitchCase="'iconAction'">
                                <twc-icon shape="{{(row | resolveProperty: item.field)?.icon }}"
                                    twcTooltip="{{(row | resolveProperty: item.field)?.tooltip | translate}}"
                                    placement="top" class="action"
                                    (click)="emitIconAction(item.field,row, idx, $event)"></twc-icon>
                            </ng-container>

                            <ng-container *ngSwitchCase="'date'">
                                {{row | resolveProperty: item.field | localizedDate: item.dateFormat}}
                            </ng-container>

                            <div class="twc-checkbox" *ngSwitchCase="'checkbox'"
                                (click)="preventEventPropagation($event)">
                                <input class="twc-checkbox-input" type="checkbox" [id]="getCheckboxId(idx,item.id)"
                                    [(ngModel)]="row.selected" (ngModelChange)="onElementChecked(row)">
                                <label class="twc-checkbox-label" [for]="getCheckboxId(idx,item.id)"></label>
                            </div>

                            <twc-menu-wrapper *ngSwitchCase="'menuOption'">
                                <twc-icon shape="ellipsis" class="cursor-pointer"></twc-icon>
                                <twc-menu position="left-bottom">
                                    <ng-container *ngFor="let menuOption of row.secondaryMenuOptions">
                                        <twc-menu-option (click)="onSecondaryMenuClicked(menuOption, row)">
                                            {{ menuOption.keyText| translate}}
                                        </twc-menu-option>
                                    </ng-container>
                                </twc-menu>
                            </twc-menu-wrapper>

                            <ng-container *ngSwitchCase="'link'">
                                <span class="pointer link-field" (click)="emitLinkClick(row, item.field, $event)">
                                    {{row | resolveProperty: item.field}}
                                </span>
                            </ng-container>

                            <ng-container *ngSwitchCase="'list'">
                                <ul>
                                    <li *ngFor="let option of row.options"> {{option}}</li>
                                </ul>
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                {{item.format?.(row) ?? (row | resolveProperty: item.field) }}
                            </ng-container>
                        </ng-container>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </table>
</div>
<div *ngIf="showPagination" class="paginator-container twc-mt-2">
    <twc-paginator *ngIf="pagination" cwHidePaginatorControl [(pageSize)]="pagination.pageSize"
        [length]="pagination.totalElements" [(current)]="pagination.currentPage" (currentChange)="onChangePage($event)">
    </twc-paginator>
</div>